module.exports = __webpack_public_path__ + "deefd5d94e219ea6ad731c6a1a587b5d.svg";